export default __webpack_public_path__ + "static/icon-47aefa8eb85e666adc51b3becb314a37.png";